import React from "react";
import LicensePlate from "../LicensePlate/LicensePlate";

/**
 * Libellé véhicule « MARQUE - Modèle [plaque] ».
 *
 * Le fallback quand la marque manque appartient à l'appelant : la liste des
 * contrats affiche une erreur, la modale de détail masque tout le bloc.
 */
const VehicleLabel = ({ vehicle }) => {
  if (!vehicle?.brand) return null;

  return (
    <>
      {vehicle.brand.name} - {vehicle.brandModel?.name}
      <LicensePlate value={vehicle.immat} size="sm" className="ml-2" />
    </>
  );
};

export default VehicleLabel;
